import api from '@/api/warehouse'

const state = {
    items: [],
    pagination: null,
}

const mutations = {
    set(state, payload) {
        state.items = payload
    },
    delete(state, id) {
        let index = state.items.findIndex(x => x.id == id)
        state.items.splice(index, 1)
    },
    set_pagination(state, pag) {
        state.pagination = pag
    },
}

const actions = {
    create(context, payload) {
        return api
            .create(payload)
            .then(res => {
                console.log('create', res)
            })
            .catch(err => {
                throw err
            })
    },
    fetch(context, payload) {
        return api
            .fetch(payload.query, payload.page)
            .then(result => {
                let items = result.data.success.data.data.map(x => {
                    return x
                })
                context.commit('set', items)
                let pag = result.data.success.data
                context.commit('set_pagination', {
                    page: pag.current_page,
                    pageSize: pag.per_page,
                    total: pag.total,
                })
            })
            .catch(err => {
                throw err
            })
    },
    update(context, payload) {
        return api
            .update(payload.id, payload)
            .then(() => {})
            .catch(err => {
                throw err
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                context.commit('delete', id)
            })
            .catch(err => {
                throw err
            })
    },
}

const getters = {
    warehouses(state) {
        return state.items
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
